import React from "react"
import { TransitionGroup, CSSTransition } from "react-transition-group";
import ModelItem from './ModelItem';


const ModelList = ({models, title, remove, showZone3d}) => {
    if (!models.length) {
        return (
            <h2 style={{textAlign: 'center'}}>
            No models found... 
            </h2>
        )
    }
    return (
        <div>
            <h1 style={{textAlign: 'center'}}>
                {title} 
            </h1>
            <TransitionGroup>
                {models.map((model, ind) => 
                    <CSSTransition
                        key={model.id}
                        timeout={500}
                        classNames="model"
                    >
                    <ModelItem showZone3d={showZone3d} remove={remove} number={ind+1} model={model} />
                    </CSSTransition>
                )}
            </TransitionGroup>
        </div>
    )
}

export default ModelList

